const cssVariables = () => {
    function setVariables() {
        const body = document.querySelector("body");
        const scrollbarWidth = window.innerWidth - body.offsetWidth < 0 ? 0 : window.innerWidth - body.offsetWidth;
        let style = document.querySelector("style[data-vars='true']")
        if (!style) {
            style = document.createElement("style");
            style.dataset.vars = "true";
            body.appendChild(style);
        }
        style.innerHTML = `
            :root {
                --scrollbarWidth: ${scrollbarWidth}px;
            }
        `;

    }
    setVariables();
    window.addEventListener("resize", setVariables);
}
export default cssVariables;